import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { signupFormSiteTypes } from "../signup-form/signup-form";
import { signupFormSchema } from "../signup-form/signup-form-schema";

export const getSignupFormSchema = {
  name: "getSignupForm" as const,
  input: z.object({
    shopifyCustomerId: z.string().nullable(),
    redoCustomerId: z.string().nullish(),
    customerHash: z.string(),
    formId: z.string().nullable(),
    isOnMobile: z.boolean(),
    site: createEnum(signupFormSiteTypes).optional(),
    utmParams: z.string(),
    forceId: z.string().optional(),
    exitIntentOnly: z.boolean().optional(),
  }),
  output: z.object({
    form: signupFormSchema.nullable(),
    formId: z.string().nullable(),
    treatmentId: z.string().nullable(),
    skipPhoneSteps: z.boolean(),
    merchantPhoneNumber: z.string().optional(),
    reason: z.string().optional(),
  }),
};

export type GetSignupFormInput = z.infer<typeof getSignupFormSchema.input>;
